import { useSelector } from "react-redux";
import {
  CarsAvailabilitySelectors,
  CoreCarsComponent,
} from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { useCarsStyles } from "../../hooks";
import defaultStyles from "./styles.module.scss";

interface CarCardPriceProps extends PlatformComponentProps {
  totalPrice: string;
  pricePerDay: string;
  position?: "left" | "right";
  mapView?: boolean;
  additionalPriceInfo?: React.ReactNode;
}

export const CarCardPrice: React.FC<CarCardPriceProps> = ({
  totalPrice,
  pricePerDay,
  position = "left",
  mapView = false,
  className,
  additionalPriceInfo,
}) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY = CoreCarsComponent.CarCardPrice;
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const totalDays = useSelector(CarsAvailabilitySelectors.getTotalDays);

  return (
    <div className={clsx(block, className, cn(position))}>
      {mapView ? (
        <div>
          <Trans
            i18nKey="apac.cars.vehicleCard.priceForDays"
            values={{ count: 1, price: pricePerDay }}
            components={[<span className={cn("price-per-night")} />]}
          />
        </div>
      ) : (
        <>
          <div className={cn("price-per-night")}>
            <Trans
              i18nKey="apac.cars.vehicleCard.pricePerDay"
              values={{ price: pricePerDay }}
              components={[<span className={cn("price-per-night-value")} />]}
            />
          </div>
          <div className={cn("total-price")}>
            {totalDays != null && (
              <Trans
                i18nKey="apac.cars.vehicleCard.priceForDays"
                values={{ count: totalDays, price: totalPrice }}
                components={[<span />]}
              />
            )}
          </div>
          <div className={cn("fees-note")}>{t("feesAndTaxesIncluded")}</div>
          {additionalPriceInfo}
        </>
      )}
    </div>
  );
};
